import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import {
  setClickOnMaintainCheckVal,
  setDisplayCheckTableData,
} from '../../../Display/Check/store/action';

export const dispatchUserRole = (values) => {
  return {
    loginUseRole: values,
    type: actionTypes.GET_USER_ROLE,
  };
};

export const dispatchCheckSearchValues = (values) => {
  return {
    checkSearchValues: values,
    type: actionTypes.SEARCH_CHECK_VALUES,
  };
};

export const dispatchSaveCheckValues = (values) => {
  return {
    saveCheckValues: values,
    type: actionTypes.SAVE_CHECK_VALUES,
  };
};

export const dispatchDeleteCheckValues = (values) => {
  return {
    deleteCheckValues: values,
    type: actionTypes.DELETE_CHECK_VALUES,
  };
};

export const dispatchAlluserId = (values) => {
  return {
    getAllLastUserIds: values,
    type: actionTypes.ALL_LAST_UPDATED_USER_ID,
  };
};

export const dispatchGetGeneralSystemParametersResultDetails = (data) => ({
  type: actionTypes.GET_GENERAL_SYSTEM_PARAMETER_CHECK,
  generalSystemParameter: data,
});

export const searchCheckReqAction = (data) => {
  return {
    type: 'SEARCH_CHECK_REQUEST',
    payload: data,
  };
};
export const checkSearchFormErrorAction = (data) => {
  return {
    type: 'SEARCH_CHECK_ERROR_REQUEST',
    payload: data,
  };
};
export const checkSearchErrorMessageAction = (data) => {
  return {
    type: 'SEARCH_CHECK_ERROR_MESSAGE',
    payload: data,
  };
};
export const maintainCheckReqAction = (data) => {
  return {
    type: 'MAINTAIN_CHECK_REQUEST',
    payload: data,
  };
};
export const maintainCheckFormErrorAction = (data) => {
  return {
    type: 'MAINTAIN_CHECK_ERROR_REQUEST',
    payload: data,
  };
};
export const maintainCheckErrorMessageAction = (data) => {
  return {
    type: 'MAINTAIN_CHECK_ERROR_MESSAGE',
    payload: data,
  };
};

export const getSearchCheckResults =
  (values, clickOnMaintainCheckVal) => (dispatch) => {
    return axios
      .post(`${serviceEndPoint.SEARCH_CHECK_RESULTS}`, values)
      .then((response) => {
        if (clickOnMaintainCheckVal) {
          return dispatch(setDisplayCheckTableData(response.data.data));
        }
        dispatch(setClickOnMaintainCheckVal(false));
        return dispatch(dispatchCheckSearchValues(response.data.data));
      })
      .catch(() => {
        dispatch(dispatchCheckSearchValues({ error: 'API failed' }));
      });
  };

export const getSaveCheckValuesResults = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SAVE_CHECK_VALUES}`, values)
    .then((response) => {
      return dispatch(dispatchSaveCheckValues(response.data));
    })
    .catch(() => {
      dispatch(dispatchSaveCheckValues({ error: 'API failed' }));
    });
};

export const deleteCheckValuesResults = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.DELETE_CHECK_VALUES}`, values)
    .then((response) => {
      return dispatch(dispatchDeleteCheckValues(response.data));
    })
    .catch(() => {
      dispatch(dispatchDeleteCheckValues({ error: 'API failed' }));
    });
};

export const getAllLastUserId = () => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.GET_ALL_LAST_UPDATED_USER_ID}`, '')
    .then((response) => {
      return dispatch(dispatchAlluserId(response.data.data));
    })
    .catch(() => {
      dispatch(dispatchAlluserId({ error: 'API failed' }));
    });
};

export const getgeneralsystemparameterDetails = (values) => (dispatch) => {
  return axios
    .get(serviceEndPoint.GET_GENERAL_SYSTEM_PARAMETER, values)
    .then((response) => {
      dispatch(
        dispatchGetGeneralSystemParametersResultDetails(response?.data?.data)
      );
    })
    .catch((error) => {
      dispatch(dispatchGetGeneralSystemParametersResultDetails(error.response));
    });
};

export const getExistingCorrLinkIds = (value) => {
  return axios
    .post(serviceEndPoint.GET_EXISTING_COMMENT_LINK_IDS, value)
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};
export const clearReduxMaintainCheckSearchScreen = () => (dispatch) => {
  dispatch(searchCheckReqAction({}));
  dispatch(checkSearchFormErrorAction({}));
  dispatch(checkSearchErrorMessageAction([]));
  dispatch(dispatchCheckSearchValues([]));
};

export const clearReduxMaintainCheckDetailScreen = () => (dispatch) => {
  dispatch(maintainCheckReqAction({}));
  dispatch(maintainCheckFormErrorAction({}));
  dispatch(maintainCheckErrorMessageAction([]));
  dispatch(dispatchSaveCheckValues({}));
  dispatch(dispatchAlluserId([]));
  dispatch(dispatchGetGeneralSystemParametersResultDetails([]));
};
